<template>
  <div class="Footer">
    <div class="container-flued">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div class="logo"><img src="@/assets/logo.png" /></div>
            <p>Best Lead provider <br />within the region</p>
          </div>
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-4">
                <a href="#" @click.prevent="goto('Home')">HOME</a>
              </div>
              <div class="col-lg-4">
                <a href="#" @click.prevent="goto('AboutUs')">ABOUT US</a>
              </div>
              <div class="col-lg-4">
                <a href="#" @click.prevent="goto('ContactUs')">Contact Us</a>
                <!-- <div class="subFMenu">
                  <a href="#">Action</a>
                  <a href="#">Another action</a>
                  <a href="#">Some thing else</a>
                </div> -->
              </div>
            </div>
          </div>
          <div class="col-lg-12 allRights">
            ALL RIGHTS RESERVED |
            <span @click.prevent="goto('PrivacyPolicy')">PRIVACY POLICY</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterCom',
  props: {
    msg: String,
  },
  methods: {
    goto(selectedName) {
      this.$router.push({ name: selectedName, replace: true });
      setTimeout(function () {
        location.reload();
      }, 100);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Footer {
  background-image: url('@/assets/productBg.png');
  background-color: rgba(0, 52, 120, 0.03);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding-bottom: 20px;
  padding-top: 60px;
  .logo {
    color: #242f9b;
    font-family: Open Sans;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  p {
    color: #292341;
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-transform: capitalize;
    margin-top: 20px;
  }
  a {
    width: 100%;
    text-align: center;
    text-decoration: none;
    display: block;
    color: #292341;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-top: 40px;
  }
  .subFMenu {
    margin-top: 10px;
    margin-bottom: 5px;
    a {
      text-align: left;
      border-left: 2px solid #ffc93c;
      margin-top: 5px;
      padding-left: 10px;
    }
  }
  .allRights {
    color: #292341;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: capitalize;
    text-align: center;
    margin-top: 60px;
    span {
      cursor: pointer;
    }
  }
}
@media screen and (max-width: 992px) {
  .Footer {
    padding-top: 20px;
    padding-bottom: 10px;
    p {
      width: 100%;
    }
    a {
      text-align: left;
      margin-top: 10px;
    }
  }
}
</style>
